import { render, staticRenderFns } from "./commFaq.vue?vue&type=template&id=1be1c896&scoped=true&"
import script from "./commFaq.vue?vue&type=script&lang=js&"
export * from "./commFaq.vue?vue&type=script&lang=js&"
import style0 from "./commFaq.vue?vue&type=style&index=0&id=1be1c896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be1c896",
  null
  
)

export default component.exports